import { t } from '@/ui/i18n/i18n';

export const inspectionExportTypes: Record<string, string> = {
  pdf: t('common.pdf'),
  images: t('common.images'),
  word: t('common.word'),
  excel: t('common.excel'),
  excelSimple: t('common.excel-simple'),
  csv: t('common.csv'),
};
